import { CardValue } from '../../models/communication/cards.enum';
import { CardPosition, HandValueKey, SidePosition } from '../../models/communication/games.model';

export interface GameViewModel {
    title: { text: string; isSpecial: boolean };
    shrinkMode: boolean;
    sides: SideModel[];
    hands: HandModel[];
    cards: CardModel[];
}

export interface SideModel {
    position: SidePosition;
    hands: HandModel[];
    state: SideState;
    label?: string;
}

export interface HandModel {
    parentSide: SideModel;
    handValueKey?: HandValueKey;
    sideIndex: number;
    label: string;
    state: HandState;
    cards: CardModel[];
    amount: { value: number; visible: boolean };
}

export interface CardModel {
    position: CardPosition;
    parentHand: HandModel;
    state: CardState;
    value: CardValue;
    isRotated: boolean;
    isCompact: boolean;
    isInteractive?: boolean;
    isDisabled?: boolean;
    isIncorrect?: boolean;
    isCorrected?: boolean;
}

export enum CardState {
    Show = 'show',
    Back = 'back',
    Checked = 'checked',
    Hidden = 'hidden',
    Empty = 'empty',
    MessageFaceDown = 'message-face-down',
    MessageFaceUp = 'message-face-up',
    MessageFlipCard = 'message-flip-card'
}

export enum SideState {
    Default = 'default',
    Current = 'current',
    Muted = 'muted',
    Win = 'win',
    Tie = 'tie'
}

export enum HandState {
    Default = 'default',
    Muted = 'muted'
}
